// 旅拍-行程-酒店选择不含的value值
export const HOTEL_PLANE_VALUE = 714
// 场景-纯内景
export const ONLY_INTERIOR = 27
// 场景-纯外景
export const ONLY_LOCATION = 28
// 场景-内景+外景
export const ALL_SCENES = 29

export const MAN_RING_WITHOUT_DIAMOND = [
  'ring_man_diamond_weight',
  'ring_man_certificate',
  'ring_man_diamond_color',
  'ring_man_diamond_pure',
  'ring_man_diamond_cut'
]

export const WOMAN_RING_WITHOUT_DIAMOND = [
  'ring_diamond_weight',
  'ring_certificate',
  'ring_diamond_color',
  'ring_diamond_pure',
  'ring_cut'
]

export const MAN_RING_OPTION = [
  'ring_man_material',
  'ring_man_weight',
  'ring_man_diamond',
  'ring_man_diamond_size',
  ...MAN_RING_WITHOUT_DIAMOND
]
export const WOMAN_RING_OPTION = [
  'ring_material',
  'ring_weight',
  'ring_diamond',
  'ring_diamond_size',
  ...WOMAN_RING_WITHOUT_DIAMOND
]
